/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule, UrlModule } from '@lm-nx-frontend/lm-inf-core';
import {
  IconModule,
  KeyboardFocusModule,
  PaginationModule,
  SplitViewModule,
  TableModule,
} from '@lm-nx-frontend/lm-inf-ui';
import { MessageModule } from '../message/message.module';
import { ListComponent } from './list.component';
import { PopoverModule } from '@lm-nx-frontend/lm-inf-ui';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SplitViewModule,
    TableModule,
    IconModule,
    UrlModule,
    I18nModule,
    PaginationModule,
    NgSelectModule,
    FormsModule,
    MessageModule,
    KeyboardFocusModule,
    PopoverModule,
  ],
  declarations: [ListComponent],
  exports: [ListComponent],
})
export class ListModule {}
